<script setup lang="ts">
import { inject, reactive, type Ref } from 'vue';
import type { Faq } from '@/services/api/emsl';

interface DialogRefValue {
  data?: { item?: Faq };
}

const dialogRef = inject<Ref<DialogRefValue | undefined>>('dialogRef');
const emit = defineEmits<{ (e: 'close', data?: unknown): void }>();

const item = dialogRef?.value?.data?.item;

const form = reactive({ question: item?.question ?? '', answer: item?.answer ?? '' });

function submit(): void {
  if (!form.question || !form.answer) return;
  emit('close', { ...form });
}
</script>

<template>
  <form class="faq-dialog" @submit.prevent="submit">
    <div class="faq-dialog__field">
      <label for="faq-q">Question</label>
      <input id="faq-q" v-model="form.question" type="text" required autofocus />
    </div>
    <div class="faq-dialog__field">
      <label for="faq-a">Answer</label>
      <textarea id="faq-a" v-model="form.answer" required rows="4" />
    </div>
    <div class="faq-dialog__actions">
      <button type="submit">Save</button>
      <button type="button" @click="emit('close')">Cancel</button>
    </div>
  </form>
</template>

<style scoped>
.faq-dialog {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.25rem 0 0.5rem;
  min-width: 26rem;
}
.faq-dialog__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.faq-dialog__field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}
.faq-dialog__field input,
.faq-dialog__field textarea {
  padding: 0.4rem 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font: inherit;
  resize: vertical;
}
.faq-dialog__actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}
</style>
